import React, { Component, useState, useEffect, useRef } from "react"
import classNames from "classnames"
import rehypeReact from "rehype-react"
import Note from "../components/note"
import Fig from "../components/fig"
import Illustration from "./illustration"
import { smoothSailing, isScrolling } from "../lib/scrolling"
import Fade from 'react-reveal/Fade'

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: { note: Note, fig: Fig },
}).Compiler

function useIntersection(options) {
  const [observerEntry, setEntry] = useState({})
  const elRef = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => setEntry(entries[0]),
      options
    )
    observer.observe(elRef.current)
    return () => observer.disconnect()
  }, [elRef])
  return { observerEntry, elRef }
}

const Sentinel = ({ next, active, setActive, control }) => {
  const { observerEntry, elRef } = useIntersection({
    root: null,
    rootMargin: "0px",
    threshold: [1],
  })
  const [visible, setVisible] = useState(false)

  if (observerEntry.isIntersecting) {
    if (
      typeof document !== "undefined" &&
      visible === false &&
      !isScrolling() &&
      active !== next
    ) {
      // défile à 0 à droite
      smoothSailing({
        destination: document.getElementsByClassName("split__panel--right")[0],
        container: document.getElementsByClassName("split__panel--right")[0],
      })
      setActive(next)
      setVisible(true)
    }
  } else {
    if (visible === true) {
      setVisible(false)
    }
  }

  return (
    <section
      ref={elRef}
      data-control={control}
      className={classNames("sentinel", {
        visible: observerEntry.isIntersecting,
      })}
    >
      <span role="img" aria-label="sentinel">
        👀
      </span>
    </section>
  )
}

class Left extends Component {
  render() {
    const { data } = this.props

    const sortedData = data.sort(
      (a, b) =>
        a.node.childMarkdownRemark.frontmatter.order -
        b.node.childMarkdownRemark.frontmatter.order
    )

    return (
      <div>
        {sortedData.map(({ node: { childMarkdownRemark: node } }) => (
          <div
            id={`section-left-${node.frontmatter.order}`}
            className={`section section--left section--${
              node.frontmatter.color
              } section--test section--${node.frontmatter.key}`}
            key={node.id}
          >
            <Sentinel
              control={`section-right-${node.frontmatter.order}`}
              next={node.frontmatter.order}
              active={this.props.active}
              setActive={this.props.setActive}
            />
            <Sentinel
              control={`section-right-${node.frontmatter.order}`}
              next={node.frontmatter.order}
              active={this.props.active}
              setActive={this.props.setActive}
            />
            {node.frontmatter.title && (
              <header className="section__header">
                <Fade distance={`1.5rem`} up>
                  <h2
                    className="section__heading"
                    dangerouslySetInnerHTML={{ __html: node.frontmatter.title }}
                  />
                </Fade>
              </header>
            )}

            <div className="section__content">{renderAst(node.htmlAst)}</div>
            {node.frontmatter.key === "header" && (
              <div className="section__illustration">
                <Illustration />
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default Left
